/**
 * (拟设)基金 - 直接股东/董事信息 - 表单默认值工厂 & 回显数据归一化
 * 弹窗初始化(AddOrUpdate)、回显平铺展示(index.vue) 共用，
 * 保证表单字段结构完整，避免模板访问 undefined 报错(如 representativeInfo.fullName)
 */

// ==================== 表单默认值工厂函数 ====================
export const createRepresentativeInfo = () => ({
  fullName: null,
  nationality: null,
  identificationType: null,
  identificationNo: null,
  email: null,
  phone: "",
  residentialAddress: null,
  birthDate: null,
});

export const createCompanyForm = () => ({
  isOfFund: 1,
  memberType: "CORPORATE",
  positionHeld: "SHAREHOLDER",
  fullName: null,
  nationality: null,
  businessLicenseNo: null,
  phone: "",
  email: null,
  registeredOfficeAddress: null,
  operationAddress: null,
  addressIdUrls: [],
  businessLicenseUrls: [],
  identificationUrls: [],
  holdingIdentificationUrls: [],
  sharesInfo: [],
  incorporationDate: null,
  isNominatedShareholder: 0,
  fundsInfo: [],
  representativeInfo: createRepresentativeInfo(),
});

export const createPersonalForm = () => ({
  isOfFund: 1,
  memberType: "INDIVIDUAL",
  positionHeld: "SHAREHOLDER",
  fullName: null,
  nationality: null,
  identificationType: null,
  identificationNo: null,
  email: null,
  phone: "",
  residentialAddress: null,
  addressIdUrls: [],
  businessLicenseUrls: [],
  identificationUrls: [],
  holdingIdentificationUrls: [],
  sharesInfo: [],
  birthDate: null,
  isNominatedShareholder: 0,
  isNominatedDirector: 0,
  directorNeedResigned: 0,
  isHoldShareOfPrcInland: 0,
  holdShareOfPrcEntity: null,
  fundsInfo: [],
});

// ==================== 回显数据归一化 ====================
/**
 * fundsInfo 归一化：兼容三种形态
 * 1. 对象数组 [{fundName:...}] - 直接使用
 * 2. JSON 字符串数组 ["{\"fundName\":...}"] - 逐项解析(历史数据/后端返回)
 * 3. 非数组 - 置空数组
 */
const normalizeFundsInfo = fundsInfo => {
  if (!Array.isArray(fundsInfo)) return [];
  return fundsInfo
    .map(item => {
      if (item && typeof item === "string") {
        try {
          return JSON.parse(item);
        } catch (e) {
          return null;
        }
      }
      return item;
    })
    .filter(Boolean);
};

/**
 * 公司类型 - 回显数据归一化：补全缺失字段与嵌套对象
 * row 来自后端/父组件 value，字段可能缺失，直接渲染会导致
 * v-model="form.representativeInfo.fullName" 访问 undefined 报错
 */
export const normalizeCompanyForm = row => ({
  ...createCompanyForm(),
  ...row,
  representativeInfo: { ...createRepresentativeInfo(), ...(row.representativeInfo || {}) },
  sharesInfo: Array.isArray(row.sharesInfo) ? row.sharesInfo : [],
  fundsInfo: normalizeFundsInfo(row.fundsInfo),
});

/** 个人类型 - 回显数据归一化 */
export const normalizePersonalForm = row => ({
  ...createPersonalForm(),
  ...row,
  sharesInfo: Array.isArray(row.sharesInfo) ? row.sharesInfo : [],
  fundsInfo: normalizeFundsInfo(row.fundsInfo),
});
